import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { constantToDisplayName } from "../../core/constantToDisplayName";
import { isMeDetailsFallback, useMeDetailsQuery } from 'legoland-sdk/dist/experimental';
import moment from 'moment';
import styled from 'styled-components';
import { Modal, tombac, useTombac } from 'tombac';
import { useAccessHistoryByProductQuery } from "../../users/api/userManagementApiHooks";
import { useUserDetails } from "../../users/UserDetailsProvider";
import { accessIconMap } from "./accessIconMap";
import { ProductModalHeader } from "./ProductModalHeader";
import { statusIconMap } from "./statusIconMap";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccessCell = styled.td.withConfig({
  displayName: "AccessHistoryModal__AccessCell"
})(["font-weight:bold;& > .TombacIcon{vertical-align:", ";}"], tombac.unit(-7));
const AccessRow = _ref => {
  let {
    item: {
      endDate,
      startDate,
      status,
      type
    },
    meDetails
  } = _ref;
  const tombac = useTombac();
  const formatTime = time => moment.utc(time).format(isMeDetailsFallback(meDetails) || meDetails.settings.dateFormat === 'DDMMYYYY' ? 'DD/MM/YYYY HH:mm' : 'MM/DD/YYYY HH:mm');
  const AccessIcon = accessIconMap[type];
  const StatusIcon = statusIconMap[status].icon;
  const statusIconColor = tombac.color(...statusIconMap[status].color);
  return /*#__PURE__*/_jsxs("tr", {
    "data-sentry-component": "AccessRow",
    "data-sentry-source-file": "AccessHistoryModal.tsx",
    children: [/*#__PURE__*/_jsxs(AccessCell, {
      "data-sentry-element": "AccessCell",
      "data-sentry-source-file": "AccessHistoryModal.tsx",
      "data-sentry-element": "AccessCell",
      children: [/*#__PURE__*/_jsx(AccessIcon, {
        "data-sentry-element": "AccessIcon",
        "data-sentry-source-file": "AccessHistoryModal.tsx",
        "data-sentry-element": "AccessIcon"
      }), " ", constantToDisplayName(type)]
    }), /*#__PURE__*/_jsx("td", {
      children: formatTime(startDate)
    }), /*#__PURE__*/_jsx("td", {
      children: formatTime(endDate)
    }), /*#__PURE__*/_jsxs(StatusCell, {
      iconColor: statusIconColor,
      "data-sentry-element": "StatusCell",
      "data-sentry-source-file": "AccessHistoryModal.tsx",
      "data-sentry-element": "StatusCell",
      children: [/*#__PURE__*/_jsx(StatusIcon, {
        size: "sm",
        "data-sentry-element": "StatusIcon",
        "data-sentry-source-file": "AccessHistoryModal.tsx",
        "data-sentry-element": "StatusIcon"
      }), " ", constantToDisplayName(status)]
    })]
  });
};
const Body = styled.div.withConfig({
  displayName: "AccessHistoryModal__Body"
})(["background-color:", ";border-top:", " solid ", ";padding:", ";"], tombac.color('neutral', 200), tombac.unit(1), tombac.color('neutral', 400), tombac.space(3, 4));
const StatusCell = styled.td.withConfig({
  displayName: "AccessHistoryModal__StatusCell"
})(["& > .TombacIcon{color:", ";}"], _ref2 => {
  let {
    iconColor
  } = _ref2;
  return iconColor;
});
const Table = styled.table.withConfig({
  displayName: "AccessHistoryModal__Table"
})(["background-color:", ";border:", " solid ", ";border-spacing:0;min-width:100%;", " & td,& th{border:solid ", ";border-width:", ";padding:", ";text-align:left;}& td{height:", ";}& th{height:", ";", "}"], tombac.color.white, tombac.unit(1), tombac.color('neutral', 400), tombac.text(), tombac.color('neutral', 400), tombac.unit(0, 0, 1, 0), tombac.space(0, 4), tombac.unit(46), tombac.unit(32), tombac.altText({
  fontSize: 12,
  fontWeight: 'bold'
}));
export const AccessHistoryModal = _ref3 => {
  let {
    isOpen,
    onRequestClose,
    productId
  } = _ref3;
  const meDetailsQuery = useMeDetailsQuery();
  const meDetails = meDetailsQuery.data?.meDetails;
  const user = useUserDetails();
  const historyQuery = useAccessHistoryByProductQuery({
    productId,
    username: user.email
  }, {
    enabled: isOpen
  });
  const history = historyQuery.data?.history;
  if (meDetailsQuery.isError || historyQuery.isError) {
    throw meDetailsQuery.error ?? historyQuery.error;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "AccessHistoryModal",
    "data-sentry-source-file": "AccessHistoryModal.tsx",
    children: [/*#__PURE__*/_jsx(ProductModalHeader, {
      onRequestClose: onRequestClose,
      productId: productId,
      subtitle: "Verify previous access; the full history is found at the bottom of the page.",
      title: "Access history",
      "data-sentry-element": "ProductModalHeader",
      "data-sentry-source-file": "AccessHistoryModal.tsx",
      "data-sentry-element": "ProductModalHeader"
    }), /*#__PURE__*/_jsx(Body, {
      "data-sentry-element": "Body",
      "data-sentry-source-file": "AccessHistoryModal.tsx",
      "data-sentry-element": "Body",
      children: !meDetails || !history ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsxs(Table, {
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Access"
            }), /*#__PURE__*/_jsx("th", {
              children: "Start date"
            }), /*#__PURE__*/_jsx("th", {
              children: "End date"
            }), /*#__PURE__*/_jsx("th", {
              children: "Status"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: history.map((item, index) => /*#__PURE__*/_jsx(AccessRow, {
            item: item,
            meDetails: meDetails
          }, index))
        })]
      })
    })]
  });
};